export const getEnumList = (value: Record<string, string | number>): string[] => {
    return Object.keys(value).filter(key => isNaN(Number(key)));
};

export const formatEnumName = (key: string): string => {
    return key.replace(/_/g, ' ').replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
        .replace(/([a-z\d])([A-Z])/g, '$1 $2')
        .trim();
};

export const getNamedEnum = (inputEnum: Record<string, string | number>): string[] => {
    const outputNames: string[] = [];

    for (const key in inputEnum) {
        if (typeof inputEnum[key] === 'number') {
            outputNames[inputEnum[key] as number] = formatEnumName(key);
        }
    }
    return outputNames;
};

export const getEnumLookup = (inputEnum: Record<string, string | number>): { id: number; name: string }[] => {
    return getEnumList(inputEnum).map(key => ({
        id: inputEnum[key] as number,
        name: formatEnumName(key)
    }));
};
